import styled from 'styled-components';
import { utils, Common, color } from '@stockbit/ui';

export const AttachmentContainer = styled.div`
  padding-left: 28px;
  padding-right: 14px;
  padding-bottom: 24px;
`;

export const AttachmentImageContainer = styled.div`
  display: flex;
  overflow-x: auto;
  padding: 30px 0;
`;

export const ImageItemContainer = styled.div`
  position: relative;
  margin-right: 8px;
`;

export const CloseWrapper = styled.div`
  position: absolute;
  right: 4px;
  top: 4px;
  cursor: pointer;
`;

export const AttachmentDocumentContainer = styled.div``;

export const DocumentItem = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  border: 1px solid ${color.downgray};
  box-sizing: border-box;
  border-radius: 6px;
  width: 100%;
  padding: 14px 16px;
  margin-bottom: 10px;
`;

export const ExtensionBadge = styled.span`
  padding: 0 4px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  max-height: 16px;
  background: #ee4a49;
`;
